// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'nexe... Remove this comment to see the full error message
import { biz } from 'nexedu-common'
import { Recipient } from '../../../interfaces'

export interface RecipientProperties {
  // number of delivery targets (stage / divisions / students picked in the form),
  // NOT the number of people that end up receiving the comunicado: the back-end
  // expands those into students/guardians
  recipient_count: number
  // distinct recipient types, e.g. 'division,user' or 'stage'
  recipient_types: string
  // the form was left empty, so the topic went out to the whole stage
  is_stage_wide: boolean
}

export function buildRecipientProperties (recipients?: Recipient[]): RecipientProperties {
  const list = recipients || []
  const types = list.map(recipient => recipient.type).filter(type => !!type)
  const uniqueTypes = types.filter((type, index) => types.indexOf(type) === index)

  return {
    recipient_count: list.length,
    recipient_types: uniqueTypes.join(','),
    is_stage_wide: uniqueTypes.length === 1 && uniqueTypes[0] === biz.RECIPIENT_TYPES.STAGE
  }
}
